import BaseProxy from './BaseProxy';

class Lesson extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/lessons', parameters);
    }

    async unlock(params) {
        return this.submit('post', '/unlock', params);
    }
}

export default Lesson;



// WEBPACK FOOTER //
// ./src/api/Lesson.js